import { Component, OnInit,Input  } from '@angular/core';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { Dep } from '../../comm/class/auth';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-userandactive',
    templateUrl: './userandactive.component.html',
    styleUrls: ['./userandactive.component.css']
})
export class UserandactiveComponent implements OnInit {
    @Input() post: any; // 如果需要使用 post，可以通过 @Input() 传递
    @Input() active: any; // 如果需要使用 post，可以通过 @Input() 传递

    showLink: boolean = false;
    hideTimer: any;
    link:string = environment.link;
    localPost: any; // 新增一个局部变量
    referral_url = '';
	power_id = 0;

    constructor(public httpClient: HttpClient) { }

    ngOnInit(): void {
        this.localPost = { ...this.post }; // 创建本地变量，避免直接修改输入属性
		this.power_id = Dep.getData().powers.power_id;

        if(this.active == 1){
            this.localPost.name = this.localPost.from_name;
            this.localPost.uid = this.localPost.ufuid;
            this.localPost.v_name = this.localPost.v_fname;
            this.localPost.identity = this.localPost.from_identity;
        }

        if(this.active == 2){
            this.localPost.name = this.localPost.to_name;
            this.localPost.uid = this.localPost.to_uid;
            this.localPost.v_name = this.localPost.v_tname;
            this.localPost.identity = this.localPost.to_identity;
        }

        if(this.active == 3){
            this.localPost.name = this.localPost.each_name;
            this.localPost.uid = this.localPost.each_uid;
        }

        if(this.active == 4){
            this.localPost.uid = this.localPost.user_uid;
        }

        if(this.active == 5){
            this.localPost.name = this.localPost.target_user_name;
            this.localPost.uid = this.localPost.target_user_uid;
        }

        if(this.active == 6){
            if(this.localPost.male_name != null){
                this.localPost.name = this.localPost.male_name;
                this.localPost.uid = this.localPost.male_uid;
            } else {
                console.log("userandactive: 傳入的male_name值為null");
            }
        }

        if(this.active == 7){
            if(this.localPost.female_name != null){
                this.localPost.name = this.localPost.female_name;
                this.localPost.uid = this.localPost.female_uid;
            } else {
                console.log("userandactive: 傳入的female_name值為null");
            }
        }
    }

    async copyToClipboard(localPost) {
        const body = {type: 2, info: localPost};

        this.httpClient.post<any>("/create_fake_user.php", body).subscribe(res => {
            if(res.status) {
                Swal.fire({
                    title: "推薦碼連結",
                    html: `
                        <input type="text"
                               value="${res.referral}"
                               readonly
                               id="referralInput"
                               style="width:100%; padding:10px; margin:10px 0;
                                      font-size:14px; border:1px solid #ddd;
                                      border-radius:5px;">
                        <button id="copyBtn"
                                style="width:100%; padding:12px; background:#3085d6;
                                       color:white; border:none; border-radius:5px;
                                       font-size:16px; cursor:pointer;">
                            📋 點此複製
                        </button>
                    `,
                    showConfirmButton: false,
                    showCloseButton: true,
                    didOpen: () => {
                        const btn = document.getElementById('copyBtn');
                        const input = document.getElementById('referralInput') as HTMLInputElement;

                        btn.addEventListener('click', async () => {
                            try {
                                await navigator.clipboard.writeText(res.referral);
                                btn.innerHTML = '✅ 已複製!';
                                btn.style.background = '#28a745';
                                setTimeout(() => Swal.close(), 1000);
                            } catch (err) {
                                // 備用方案
                                input.select();
                                document.execCommand('copy');
                                btn.innerHTML = '✅ 已複製!';
                                setTimeout(() => Swal.close(), 1000);
                            }
                        });

                        // 關鍵:自動觸發點擊
                        setTimeout(() => {
                            btn.click();
                        }, 300); // 延遲 300ms 確保 DOM 完全載入
                    }
                });
            }
        });
    }

    startHideTimer() {
        this.hideTimer = setTimeout(() => {
          this.showLink = false;
        }, 5000);
    }

    cancelHideTimer() {
        clearTimeout(this.hideTimer); // 取消隐藏计时器
    }

}
